import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';

export default class Navigation
extends React.Component {
	state = {};

	render () {
		const { active } = this.state;

		const LinkItem = ({ activeSlug, label, to }) => (
			<NavLink
				className={ active === activeSlug ? 'active' : '' }
				onClick={ () => { this.setState({active: activeSlug}) } }
				exact to={ to }
			>
				{ label }
			</NavLink>
		);

		return (
			<Fragment>
				<div className="grid-x">
					<div className="cell auto">
						<nav>
							<ul className="menu horizontal artist-nav">
								<li>
									<LinkItem
										label="Artist FAQs"
										activeSlug="ARTIST_FAQ"
										to="/manage-documents/ARTIST_FAQ"
									/>
								</li>
								<li>
									<LinkItem
										label="Fan FAQs"
										activeSlug="FAN_FAQ"
										to="/manage-documents/FAN_FAQ"
									/>
								</li>
								<li>
									<LinkItem
										label="Terms of Service"
										activeSlug="TOS"
										to="/manage-documents/TOS"
									/>
								</li>
								<li>
									<LinkItem
										label="Privacy Policy"
										activeSlug="PRIVACY"
										to="/manage-documents/PRIVACY"
									/>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</Fragment>
		);
	}
}
